import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const UPSERT_INTEGRATION = 'UPSERT_INTEGRATION'
const DELETE_INTEGRATION = 'DELETE_INTEGRATION'

export const upsertIntegrationApi = apiCall(
  UPSERT_INTEGRATION,
  ({
    siteId,
    provider,
    ...payload
  }: {
    siteId: string
    provider: string
    enabled: boolean
    config?: Record<string, unknown>
  }) => ({
    endpoint: getApiUrl(
      `/api/cms/v1/sites/${siteId}/integrations/${provider}`,
    ),
    method: 'PUT',
    body: payload,
    headers: appApiHeaders(),
  }),
)

export const deleteIntegrationApi = apiCall(
  DELETE_INTEGRATION,
  ({ siteId, provider }: { siteId: string; provider: string }) => ({
    endpoint: getApiUrl(
      `/api/cms/v1/sites/${siteId}/integrations/${provider}`,
    ),
    method: 'DELETE',
    headers: appApiHeaders(),
  }),
)
